<template>
    <v-dialog v-model="isOpen" persistent width="536px" class="candidate-notify">
        <v-card class="candidate-notify__card" >
            <template v-if="isToDiscarded">
                <v-card-text class="candidate-notify__card-title px-0">
                    ¿Quieres descartar a {{getNameOrQty}}?
                </v-card-text>
                <v-card-text class="candidate-notify__card-subtitle px-0">
                    <span class="candidate-notify__card-subtitle--bold">
                        Selecciona una razón para descartar la postulación. 
                    </span>
                    <br>
                    <span>
                        El postulante no verá la opción que selecciones.
                    </span>
                </v-card-text>
                <v-card-text class="px-0">
                    <table :class="`mx-auto mb-3 text-center ${errors ? 'error-reasons' : ''}`">
                        <tr>
                            <td @click="checkedReasons(0)" :class="`candidate-notify__card-field${reasons[0].checked ? '--checked' : ''}`"> 
                                {{reasons[0].type}} 
                            </td>
                            <td @click="checkedReasons(1)" :class="`candidate-notify__card-field${reasons[1].checked ? '--checked' : ''}`"> 
                                {{reasons[1].type}} 
                            </td>
                        </tr>
                        <tr>
                            <td @click="checkedReasons(2)" :class="`candidate-notify__card-field${reasons[2].checked ? '--checked' : ''}`"> 
                                {{reasons[2].type}} 
                            </td>
                            <td @click="checkedReasons(3)" :class="`candidate-notify__card-field${reasons[3].checked ? '--checked' : ''}`"> 
                                {{reasons[3].type}} 
                            </td>
                        </tr>
                        <tr>
                            <td @click="checkedReasons(4)" :class="`candidate-notify__card-field${reasons[4].checked ? '--checked' : ''}`"> 
                                {{reasons[4].type}} 
                            </td>
                            <td @click="checkedReasons(5)" :class="`candidate-notify__card-field${reasons[5].checked ? '--checked' : ''}`"> 
                                {{reasons[5].type}} 
                            </td>
                        </tr>
                    </table>
                    <span class="candidate-notify__card-message-error pa-4" v-if="errors">
                        * Debes seleccionar una opción
                    </span>
                </v-card-text>
                <v-card-text class="candidate-notify__card-checkmessage d-flex justify-end align-center px-0">
                    <v-checkbox
                        v-model="checkMessage"
                        color="#3BADFF"
                        dense
                        class="candidate-notify__card-checkmessage--check mx-0 px-0"
                        hide-details=""
                        :label="getLabelcheckbox"
                    >
                    </v-checkbox>
                </v-card-text>
                <v-card-text class="candidate-notify__card-message px-0" v-if="checkMessage">
                    <span class="candidate-notify__card-message-label">Asunto</span>
                    <v-text-field
                        v-model="message.subject"
                        single-line
                        solo
                        dense
                        hide-details
                        color="#3BADFF19"
                        class="candidate-notify__card-message-subject my-2"
                    >
                    </v-text-field>
                    <span class="candidate-notify__card-message-label">Mensaje</span>
                    <v-textarea
                        v-model="message.text"
                        solo
                        dense
                        hide-details
                        filled
                        auto-grow
                        class="candidate-notify__card-message-text mt-2"
                        v-if="!isMultiple"
                    >
                    </v-textarea>
                    <div v-else>
                        <v-textarea
                            v-text="'Hola @Nombrepostulante'"
                            solo
                            dense
                            hide-details
                            class="candidate-notify__card-message-text--nosingle top pl-3 py-2 elevation-0"
                            disabled
                        >
                        </v-textarea>
                        <v-textarea
                            v-model="message.text"
                            solo
                            dense
                            hide-details
                            filled
                            auto-grow
                            class="candidate-notify__card-message-text--nosingle bottom"
                            
                        >
                        </v-textarea>
                    </div>
                    <span class="candidate-notify__card-message-disclaimer">Edita tu mensaje antes de enviarlo.</span>
                </v-card-text>
            </template>
            <template v-else-if="isToInterviewing || isToSelected || isToSent">
                <v-card-text class="candidate-notify__card-title px-0">
                    {{getLabelTitle}}
                </v-card-text>
                <v-card-text class="candidate-notify__card-checkmessage d-flex justify-end align-center px-0">
                    <v-checkbox
                        v-model="checkMessage"
                        color="#3BADFF"
                        dense
                        class="candidate-notify__card-checkmessage--check mx-0 px-0"
                        hide-details
                        :label="getLabelcheckbox"
                        v-if="!isToSent"
                    >
                    </v-checkbox>
                </v-card-text>
                <v-card-text class="candidate-notify__card-message px-0" v-if="checkMessage">
                    <div v-if="isToInterviewing || isToSelected || candidate.status.private === 'interviewing' || candidate.status.private === 'selected'">
                        <span class="candidate-notify__card-message-label">Correo de respuesta</span>
                        <v-text-field
                            v-model="message.sender"
                            single-line
                            solo
                            dense
                            hide-details
                            placeholder="Remitente"
                            color="#3BADFF19"
                            class="candidate-notify__card-message-subject mt-2"
                        >
                        </v-text-field>
                        <span class="candidate-notify__card-message-descriptions mt-0 mb-4 px-2">*A esta casilla llegarán las respuestas de los postulante.</span>
                        <br>
                        <br>
                    </div>
                    <span class="candidate-notify__card-message-label mt-2">Asunto</span>
                    <v-text-field
                        v-model="message.subject"
                        single-line
                        solo
                        dense
                        hide-details
                        color="#3BADFF19"
                        placeholder="Asunto"
                        class="candidate-notify__card-message-subject my-2"
                    >
                    </v-text-field>
                    <span class="candidate-notify__card-message-label">Mensaje</span>
                    <v-textarea
                        v-model="message.text"
                        solo
                        dense
                        hide-details
                        filled
                        auto-grow
                        class="candidate-notify__card-message-text mt-2"
                        v-if="!isMultiple"
                    >
                    </v-textarea>
                    <div v-else>
                        <v-textarea
                            v-text="'Hola @Nombrepostulante'"
                            solo
                            dense
                            hide-details
                            class="candidate-notify__card-message-text--nosingle top pl-3 py-2 elevation-0"
                            disabled
                        >
                        </v-textarea>
                        <v-textarea
                            v-model="message.text"
                            solo
                            dense
                            hide-details
                            filled
                            auto-grow
                            class="candidate-notify__card-message-text--nosingle bottom"
                            
                        >
                        </v-textarea>
                    </div>
                    <span class="candidate-notify__card-message-disclaimer">Edita tu mensaje antes de enviarlo.</span>
                </v-card-text>
            </template>
            <template v-else>
                <v-card-text class="candidate-notify__card-title px-0">
                    {{getLabelTitle}}
                </v-card-text>
                <v-card-text class="candidate-notify__card-message px-0">
                    <div v-if="!isToInterviewing || !isToSelected">
                        <span class="candidate-notify__card-message-label">Correo de respuesta</span>
                        <v-text-field
                            v-model="message.sender"
                            single-line
                            solo
                            dense
                            hide-details
                            placeholder="Remitente"
                            color="#3BADFF19"
                            class="candidate-notify__card-message-subject mt-2"
                        >
                        </v-text-field>
                        <span class="candidate-notify__card-message-descriptions mt-0 mb-4 px-2">*A esta casilla llegarán las respuestas de los postulante.</span>
                        <br>
                        <br>
                    </div>
                    <span class="candidate-notify__card-message-label mt-2">Asunto</span>
                    <v-text-field
                        v-model="message.subject"
                        single-line
                        solo
                        dense
                        hide-details
                        color="#3BADFF19"
                        placeholder="Asunto"
                        class="candidate-notify__card-message-subject my-2"
                    >
                    </v-text-field>
                    <span class="candidate-notify__card-message-label">Mensaje</span>
                    <v-textarea
                        v-model="message.text"
                        solo
                        dense
                        hide-details
                        filled
                        auto-grow
                        class="candidate-notify__card-message-text mt-2"
                        v-if="!isMultiple"
                    >
                    </v-textarea>
                    <div v-else>
                        <v-textarea
                            v-text="'Hola @Nombrepostulante'"
                            solo
                            dense
                            hide-details
                            class="candidate-notify__card-message-text--nosingle top pl-3 py-2 elevation-0"
                            disabled
                        >
                        </v-textarea>
                        <v-textarea
                            v-model="message.text"
                            solo
                            dense
                            hide-details
                            filled
                            auto-grow
                            class="candidate-notify__card-message-text--nosingle bottom"
                            
                        >
                        </v-textarea>
                    </div>
                    <span class="candidate-notify__card-message-disclaimer">Edita tu mensaje antes de enviarlo.</span>
                </v-card-text>
            </template>
            <v-card-actions class="candidate-notify__card d-flex justify-end align-center mx-0 px-0">
                <v-btn
                    @click="closeDialog"
                    outlined
                    color="#3BADFF"
                    dark
                    :disabled="isLoading"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    :loading="isLoading"
                    @click="confirmed"
                    outlined
                    color="#3BADFF"
                    dark
                    class="px-5"
                >
                    <!-- :disabled="isToDiscarded && isThereAnyReason" -->
                    {{getLabelBtn}}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import { datetime, currentImg } from "@/libs/mixins";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "NotifyCandidate",
    props: {
        context: {
            type: Object,
        },
        dialogNotify: {
            type: Boolean,
            default: false,
        },
        toCol: {
            type: Object,
        },
        offer: {
            type: Object
        }
    }, 
    mixins: [datetime, currentImg],
    data() {
        return {
            isLoading: false,
            checkMessage: false,
            isOpen: false,
            message: {
                checked: false,
                to: [],
                names: [],
                subject: "",
                text: ""
            },
            errors: false,
            reasons: [
                {
                    id: 0,
                    checked: false,
                    type: "Sin razón"
                },
                {
                    id: 1,
                    checked: false,
                    type: "Rechazó la oferta"
                },
                {
                    id: 2,
                    checked: false,
                    type: "Fuera del rango de sueldo"
                },
                {
                    id: 3,
                    checked: false,
                    type: "No responde mensajes o llamadas"
                },
                {
                    id: 4,
                    checked: false,
                    type: "No pasó pruebas o entrevistas"
                },
                {
                    id: 5,
                    checked: false,
                    type: "No cumple el perfil del cargo"
                },
            ]    
        };
    },
    computed: {
        ...mapGetters("users", ["getUser", "getOrganization"]),
        isThereAnyReason() {
            return this.reasons.every(r => !r.checked);
        },
        getLabelcheckbox() {
            if (this.isToInterviewing) {
                return "Envía un mensaje para coordinar una entrevista";
            }
            if (!this.isMultiple) {
                return "Envía un mensaje a para notificar";
            }
            return "Envía un mensaje a para notificar a los/as postulantes";
        },
        getLabelTitle() {
            if (this.context.new && !this.context.globalCheck) {
                if (this.context.new === "selected" && this.context.users.length === 1) {
                    return `Envía un mensaje a ${this.getNameOrQty} para avisarle que ha sido seleccionado/a`;
                } else if (this.context.new === "interviewing" && this.context.users.length === 1) {
                    return `Envía un mensaje ${this.getNameOrQty} para coordinar una entrevista`;
                } else if (this.context.new === "discarded" && this.context.users.length === 1) {
                    return `Envía un mensaje de descarte a ${this.getNameOrQty}`;
                } else {
                    return `Envía un mensaje a ${this.getNameOrQty}`;
                } 
            } else if (this.context.new && this.context.globalCheck) {
                if (this.context.new === "discarded") {
                    if (this.isMultiple) {
                        return "Envía un mensaje de descarte a los/las postulantes";
                    }
                    return `Envía un mensaje de descarte a ${this.getNameOrQty}`;
                } else if (this.context.new === "interviewing") {
                    if (this.isMultiple) {
                        return `Envía un mensaje a los/as seleccionados/as para coordinar una entrevista (${this.getNameOrQty})`;
                    }
                    return `Envía un mensaje ${this.getNameOrQty} para coordinar una entrevista`;
                } else if (this.context.new === "discarded") {
                    if (this.isMultiple) {
                        return "Envía un mensaje de descarte a los/las postulantes";
                    }
                    return `Envía un mensaje de descarte a ${this.getNameOrQty}`;
                } else if (this.context.new === "selected") {
                    return `Envía un mensaje a ${this.getNameOrQty} para avisarle que ha sido seleccionado/a`;
                } else {
                    return `Envía un mensaje a ${this.getNameOrQty}`;
                }
            } else {
                if (this.isToInterviewing) {
                    return `Estás enviando a ${this.getNameOrQty} a etapa de entrevistas`;
                } else if (this.isToSent) {
                    return `Estás enviando a ${this.getNameOrQty} etapa de postulante`;
                } else if (this.isToSelected) {
                    return `Estás enviando a ${this.getNameOrQty} etapa de seleccionado`;
                }
            }
            return "";
        },
        getLabelBtn() {
            if (this.isToDiscarded) {
                if (this.checkMessage) {
                    return "Descartar y enviar"; 
                } else {
                    return "Descartar sin mensaje"; 
                }
            }
            return this.checkMessage ? "Aceptar y enviar mensaje" : "Aceptar";
        },
        messageSelected() {
            return {
                multiple: `¿Cómo estás? Esperamos que muy bien.\n\nQueremos darte una excelente noticia. Hemos finalizado el proceso de\nselección para el cargo ${this.offer.title} y tú has sido seleccionad@.\nEstamos muy contentos que te integres al equipo de ${this.offer.organization}.\nPronto te contactaremos para darte más detalles de las condiciones de tu\ningreso.\n\n¡Muchas Felicitaciones y todo lo mejor en esta nueva etapa!\n`,
                single: `Hola ${this.getNameOrQty}\n\n¿Cómo estás? Esperamos que muy bien.\n\nQueremos darte una excelente noticia. Hemos finalizado el proceso de\nselección para el cargo ${this.offer.title} y tú has sido seleccionad@.\nEstamos muy contentos que te integres al equipo de ${this.offer.organization}.\nPronto te contactaremos para darte más detalles de las condiciones de tu\ningreso.\n\n¡Muchas Felicitaciones y todo lo mejor en esta nueva etapa!\n`
            };
        },
        messageInterviewing() {
            return {
                multiple: `Junto con saludarte, te escribimos por tu postulación al cargo de ${this.offer.title} para ${this.offer.organization}. Quisiéramos invitarte a participar en una entrevista el día #FECHA a las #HORAS a través de la plataforma #NombrePlataforma. Por favor envía tu respuesta al ${this.getUser.email} para confirmar tu entrevista o buscar otras opciones de agenda.\n\nSaludos, ${this.offer.organization}\n`,
                single: `Hola ${this.getNameOrQty}!\n\nJunto con saludarte, te escribimos por tu postulación al cargo de ${this.offer.title} para ${this.offer.organization}.\n\nQuisiéramos invitarte a participar en una entrevista el día #FECHA a las #HORAS a través de la plataforma #NombrePlataforma.\n\nPor favor envía tu respuesta al ${this.getUser.email} para confirmar tu entrevista o buscar otras opciones de agenda.\n\nSaludos,\n${this.offer.organization}\n`
            };
        },
        messageDiscarded() { 
            return {
                multiple: `Queremos agradecer enormemente tu interés al cargo ${this.offer.title} de ${this.offer.organization}, sin embargo en esta ocasión hemos decidido avanzar sin tu postulación. Te invitamos desde ya a seguir atento y ser parte de futuros procesos.\n\nUn abrazo, ${this.offer.organization}\n\n`,
                single: `Hola ${this.getNameOrQty},\n\nqueremos agradecer enormemente tu interés al cargo ${this.offer.title} de ${this.offer.organization}, sin embargo en esta ocasión hemos decidido avanzar sin tu postulación.\n\nTe invitamos desde ya a seguir atento y ser parte de futuros procesos.\n\nUn abrazo,\n${this.offer.organization}\n`
            };
        },
        isMultiple() {
            return this.context && this.context.users && this.context.users.length > 1;
        },
        isToDiscarded() {
            return this.context && this.context.toDiscarded;  
            // return true;//this.context && this.context.toDiscarded;  
        },
        isToInterviewing() {
            return this.context && this.context.toInterviewing;  
        },
        isToSent() {
            return this.context && this.context.toSent;  
        },
        isToSelected() {
            return this.context && this.context.toSelected;  
        },
        getNameOrQty() {
            if (this.context && this.context.users) {
                if (this.context.users.length > 1) {
                    return `${this.context.users.length} postulantes`;
                }
                return this.context.users[0].name;
            }
            return "";
        },
    },
    watch: {
        errors() {
            console.info("errors: ", this.errors);
        },
        context() {
            this.message = {
                checked: false,
                to: [],
                names: [],
                subject: "",
                text: ""
            };
            this.reasons.map(r => r.checked = false);
            if (this.context && this.context.new) {
                if (this.context.new === "discarded") {
                    this.message.text = this.isMultiple ? this.messageDiscarded.multiple : this.messageDiscarded.single;
                    this.message.subject = "¡Gracias por tu postulación!";
                } else if (this.context.new === "interviewing") {
                    this.message.text = this.isMultiple ? this.messageInterviewing.multiple : this.messageInterviewing.single;
                    this.message.subject = `¡Queremos conocerte! Postulación al cargo ${this.offer.title}`;
                } else if (this.context.new === "selected") {
                    this.message.text = this.isMultiple ? this.messageSelected.multiple : this.messageSelected.single;
                    this.message.subject = "¡Tenemos muy buenas noticias!";
                } else {
                    this.message.text = "Escribe tu mensaje";
                }
                this.message.sender = this.getUser.email;
                this.message.to = this.context.users.map(user => ({ addr: user.email, name: user.name }));
            }
        },
        dialogNotify() {
            this.isOpen = this.dialogNotify || false;
        },
        checkMessage() {
            if (!this.checkMessage) {
                this.message.text = "";
                this.message.subject = "";
                return;
            }
            if (this.isToDiscarded) {
                this.message.text = this.isMultiple ? this.messageDiscarded.multiple : this.messageDiscarded.single;
                this.message.to = this.context.users.map(user => ({ addr: user.email, name: user.name }));
                this.message.subject = "¡Gracias por tu postulación!";
            } else if (this.isToInterviewing) {
                this.message.text = this.isMultiple ? this.messageInterviewing.multiple : this.messageInterviewing.single;
                this.message.to = this.context.users.map(user => ({ addr: user.email, name: user.name }));
                this.message.subject = `¡Queremos conocerte! Postulación al cargo ${this.offer.title}`;
                this.message.sender = this.getUser.email;
            } else if (this.isToSelected) {
                this.message.to = this.context.users.map(user => ({ addr: user.email, name: user.name }));
                this.message.sender = this.getUser.email;
            }
        }
    },
    methods: {
        ...mapActions("notifications", ["sendEmail"]),
        ...mapActions("users", ["postUpdate"]),
        checkedReasons(i) {
            this.reasons.map(r => r.checked = false);
            this.errors = false;
            this.reasons[i].checked = true;
        },
        closeDialog() {
            this.isLoading = false;
            this.checkMessage = false;
            this.$emit("cancel");
        },
        async sendNotify(values) {
            try {
                await this.sendEmail(values);
            } catch (error) {
                console.error(error);
            }
        },
        async update(values) {
            try {
                await this.context.users.forEach(async(element) => {
                    const reasons = await values.map(i => i.type);
                    await this.$store.dispatch("users/postUpdate", {
                        offerId: this.offer.id,
                        postulations: [{
                            id: element.postId,
                            reasons
                        }],
                    });
                });
            } catch (error) {
                console.error(error);
            }
        },
        async confirmed() {
            try {
                this.isLoading = true;
                if (this.isToDiscarded && this.isThereAnyReason) {
                    this.errors = true;
                    this.isLoading = false;
                    return; 
                } else {
                    this.errors = false;
                }
                if (!(this.context && this.context.new)) {
                    if (this.isMultiple) {
                        this.$emit("confirmedGlobal", this.toCol);
                    } else {
                        this.$emit("confirmed", this.toCol);
                    } 
                }
                if (this.checkMessage || this.context.new) {
                    const email = {
                        service: {
                            subject: this.message.subject,
                            template: this.message.to.length > 1 ? "general-multiple" : "general" 
                        },
                        context: {
                            message: this.message.text,
                            names: this.message.names
                        }
                    };
                    if (this.isToInterviewing || this.context.new) {
                        email.service.template = this.message.to.length > 1 ? "general-sender-multiple" : "general-sender";
                        email.context.sender = this.message.sender;
                        email.context.subject = this.message.subject;
                    }
                    
                    this.message.to.forEach(async(to) => {
                        await this.sendEmail({
                            ...email,
                            to: to.addr,
                            context: {
                                ...email.context,
                                name: to.name
                            }
                        });
                    });
                    await this.postUpdate({
                        offerId: this.offer.id,
                        postulations: this.context.users.map(i => ({
                            id: i.postId, 
                            notified: {
                                sent: this.context.new === "sent" || this.isToSent, 
                                selected: this.context.new === "selected" || this.isToSelected, 
                                discarded: this.context.new === "discarded" || this.isToDiscarded, 
                                interviewing: this.context.new === "interviewing" || this.isToInterviewing
                            }
                        }))
                    });
                    // if (this.context && this.context.new && this.context.new !== "no-context") {
                    //     }
                    this.$emit("updatePost", this.context.users.map(u => ({
                        id: u.postId,
                        status: u.status,
                        notified: {
                            sent: this.context.new === "sent" || this.isToSent, 
                            selected: this.context.new === "selected" || this.isToSelected, 
                            discarded: this.context.new === "discarded" || this.isToDiscarded, 
                            interviewing: this.context.new === "interviewing" || this.isToInterviewing
                        }
                    })));
                } 
                if (this.isToDiscarded) {
                    await this.update(this.reasons.filter(i => i.checked === true));
                    await this.reasons.forEach(i => i.checked = false);
                }
                this.$emit("close");
                this.checkMessage = false;
                this.isLoading = false;
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>
